import * as Yup from 'yup';

export const fvtLoginEmailSchema = Yup.string()
  .trim()
  .email('Enter a valid email address.')
  .required('Email is required.');

export const getFvtLoginEmailError = (email: string): string | undefined => {
  try {
    fvtLoginEmailSchema.validateSync(email);
    return undefined;
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      return error.message;
    }

    return 'Enter a valid email address.';
  }
};
